<!-- <p>{{data.name}}</p> -->
<div class="row">
    <p class="col-lg-11 col-md-11">{{data.name}}</p>
    <img class="col-lg-1 col-md-1 img" (click)="close()" src="assets/cancel.svg">
</div>